/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

/*
 * Provides:
 *  mp.api.middleware.ValuesFormatter
 *
 * Requires:
 *  mp.api.Middleware
 */

_.namespace(`mp.api.middleware`, function() {

  function ValuesFormatter() {}
  _.inherit(ValuesFormatter, mp.api.Middleware);

  ValuesFormatter.prototype.on_response = function(request, response, next) {
    response = _.reject(response, function(value) {
      return value === `` || value === `undefined` || value === `null`;
    });

    next(request, response);
  };

  return {
    ValuesFormatter,
  };

});

}.call(window));